import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SecureMediaPreview from "./SecureMediaPreview";
import {
  formatDuration,
  formatMediaDate,
  richTextToPlainText,
  sanitizeRichTextForPreview,
} from "./media.utils";

const MediaPreviewDialog = ({ open, media, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  if (!media) return null;
  const display = media;
  const duration = media.video?.durationSeconds;

  return (
    <Dialog open={open} onClose={onClose} fullScreen={fullScreen} fullWidth maxWidth="md" aria-labelledby="media-preview-title">
      <DialogTitle id="media-preview-title">Admin preview</DialogTitle>
      <DialogContent dividers className="media-preview-dialog">
        <Box className={`media-preview-assets media-preview-assets--${media.kind}`}>
          <Box><Typography variant="subtitle2">Video</Typography><SecureMediaPreview assetType="video" media={media} /></Box>
          <Box><Typography variant="subtitle2">Poster</Typography><SecureMediaPreview assetType="poster" media={media} /></Box>
        </Box>
        <Box className="media-preview-copy">
          <Box className="media-preview-statuses">
            <span className={`media-status media-status--${media.status}`}>{media.status}</span>
            <span className={`media-status media-status--${media.assetStatus}`}>{media.assetStatus}</span>
            <span className="media-status">{media.kind === "short" ? "Short" : "Video"}</span>
          </Box>
          <Typography variant="h4" component="h2">{display.title}</Typography>
          {richTextToPlainText(display.description || display.summary) ? (
            <Box
              className="media-rich-text-preview"
              dangerouslySetInnerHTML={{
                __html: sanitizeRichTextForPreview(display.description || display.summary),
              }}
            />
          ) : (
            <Typography variant="body1">No description has been added.</Typography>
          )}
          <dl className="media-preview-meta">
            <div><dt>Duration</dt><dd>{formatDuration(duration)}</dd></div>
            <div><dt>Topic</dt><dd>{display.topic || "—"}</dd></div>
            <div><dt>Destinations</dt><dd>{(media.channels || []).join(", ") || "—"}</dd></div>
            <div><dt>Created</dt><dd>{formatMediaDate(media.createdAt)}</dd></div>
            <div><dt>Published</dt><dd>{formatMediaDate(media.publishedAt)}</dd></div>
          </dl>
        </Box>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
    </Dialog>
  );
};

export default MediaPreviewDialog;
